import React, { useState } from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { MONTHS } from '../../functions/consts';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    stacked: false,
    plugins: {
        title: {
            display: true,
            text: "Graphe de l'evolution de l'activité",
        },
    },
    scales: {
        y: {
            type: 'linear',
            display: true,
            position: 'left',
        },
    },
};



const extractOperationsData = (operations) => {
    let transactions = operations.map(item => {
        let month = new Date(item.created_at).getMonth();
        month = MONTHS[month].month;
        let year = new Date(item.created_at).getFullYear();
        return month + ' ' + year;
    })
    const months = [];
    transactions.map(item => { if (!months.includes(item)) months.push(item) });
    const numbers = transactions.reduce(function (occur, i) {
        return occur[i] ? ++occur[i] : occur[i] = 1, occur;
    }, {});
    let obj = { months: months, numbers: numbers };
    return obj;
};

function StatementGraph({ operations }) {
    
    const [state, setState] = useState({ buy: extractOperationsData(operations.buy), sell: extractOperationsData(operations.sell), send: extractOperationsData(operations.send) });
    console.log("le state",state.sell.numbers)
    const data1 = {
        labels: state.buy.months,
        datasets: [
            {
                label: 'Vente de crypto',
                data: state.buy.months.map(item => state.buy.numbers[item]),
                borderColor: 'rgb(237, 108, 2)',
                backgroundColor: 'rgba(237, 108, 2, 1)',
                yAxisID: 'y',
            },
        ],
    };
    const data2 = {
        labels: state.sell.months,
        datasets: [
            {
                label: 'Rachat de crypto',
                data: state.sell.months.map(item => state.sell.numbers[item]),
                borderColor: 'rgba(46, 125, 50)',
                backgroundColor: 'rgba(46, 125, 50, 0.7)',
                yAxisID: 'y',
            },
        ],
    };
    const data3 = {
        labels: state.send.months,
        datasets: [
            {
                label: "transfert d'argent",
                data: state.send.months.map(item => state.send.numbers[item]),
                borderColor: 'rgb(156, 39, 176)',
                backgroundColor: 'rgba(156, 39, 176, 1)',
                yAxisID: 'y',
            },
        ],
    };
    return (
        <>
        <Line options={options} data={data3} />
        <Line options={options} data={data1} />
        <Line options={options} data={data2} />
        </>
    )
}

export default StatementGraph